import { render, staticRenderFns } from "./groupOrdersDateFilters.vue?vue&type=template&id=5b1e8ffe&"
import script from "./groupOrdersDateFilters.vue?vue&type=script&lang=js&"
export * from "./groupOrdersDateFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports